module.exports = __webpack_public_path__ + "132123ef6d3246606ae9a1827c8af469.png";